import React from 'react';
import { childrenOf, topSubcategories } from '../services/catalogPath';

// Native <select> of the sub-categories of one category, level-3 nodes grouped under their parent
const SubcategorySelect = ({ category, value, onChange, testId, className = '', emptyLabel = 'Aucune', disabledLabel = 'Aucune sous-catégorie définie', disabled = false }) => {
  const tops = topSubcategories(category);
  const none = tops.length === 0;
  return (
    <select data-testid={testId} value={value || ''} onChange={onChange} disabled={disabled || none} className={className}>
      <option value="">{none ? disabledLabel : emptyLabel}</option>
      {tops.map(s => {
        const kids = childrenOf(category, s);
        if (!kids.length) return <option key={s} value={s}>{s}</option>;
        return (
          <optgroup key={s} label={s}>
            <option value={s}>{s} (toute la sous-catégorie)</option>
            {kids.map(k => <option key={k} value={k}>— {k}</option>)}
          </optgroup>
        );
      })}
    </select>
  );
};

export default SubcategorySelect;
